// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteIcon_root__1wLBH"};